import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export const PrivacyPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="legal-logo">
          <img src="/logo-transparent-no-slogan.png" alt="HypeDirector" />
        </Link>
        <Link to="/" className="legal-back-link">
          Back to Home
        </Link>
      </header>

      <section className="legal-section">
        <div className="legal-container">
          <h1>Privacy Policy</h1>
          <span className="legal-updated">Last updated: 2026-01-28</span>

          <p>
            This Privacy Policy explains how HypeDirector ("we", "us") collects and uses
            information in the HypeDirector app and related services.
          </p>

          <h2>What we collect</h2>

          <h3>Information you provide</h3>
          <ul>
            <li>Account details (email, display name, password or sign-in credentials)</li>
            <li>Preferences (categories you follow, notification preferences)</li>
            <li>Customer support requests (messages you send via our contact form)</li>
          </ul>

          <h3>Information collected automatically</h3>
          <ul>
            <li>Device and app information (device identifiers, app version, language/locale)</li>
            <li>Usage events (pages viewed, buttons tapped, session and moment interactions)</li>
            <li>Crash/diagnostic logs (to improve reliability)</li>
            <li>Notification tokens (to deliver push notifications)</li>
          </ul>

          <h3>Billing information</h3>
          <p>
            If you subscribe, payments are processed by third-party payment providers (e.g., Stripe).
            We receive subscription status and limited billing metadata, but we do not store full card numbers.
          </p>

          <h3>Third-party content and links</h3>
          <p>
            The app may open official streams, odds, or offers in third-party services.
            Their privacy practices apply when you leave HypeDirector.
          </p>

          <h2>How we use information</h2>
          <ul>
            <li>Provide the service (feed, moments, following, notifications)</li>
            <li>Personalize content based on categories and follows</li>
            <li>Process subscriptions and manage access to paid features</li>
            <li>Prevent abuse and secure accounts</li>
            <li>Analyze usage to improve performance and reliability</li>
            <li>Respond to support requests</li>
          </ul>

          <h2>Sharing of information</h2>
          <p>We share information only as needed with:</p>
          <ul>
            <li>Cloud and database providers (for hosting and storage)</li>
            <li>Analytics / crash reporting providers (for reliability and product improvement)</li>
            <li>Payment providers (for subscriptions)</li>
            <li>Law enforcement or regulators when required by law</li>
          </ul>
          <p>We do not sell your personal information.</p>

          <h2>Your choices</h2>
          <ul>
            <li>You can disable notifications in device settings</li>
            <li>You can update category preferences in the app</li>
            <li>You can request data access or deletion via our <Link to="/contact">Contact</Link> page</li>
          </ul>

          <h2>Data retention</h2>
          <p>
            We keep information as long as needed to operate the service, comply with legal obligations,
            resolve disputes, and enforce agreements. We delete or anonymize data when it's no longer needed.
          </p>

          <h2>International transfers</h2>
          <p>
            If we process data outside your country, we use appropriate safeguards where required.
          </p>

          <h2>Children's privacy</h2>
          <p>
            HypeDirector is not intended for children. If you believe a child has provided personal
            information, please <Link to="/contact">contact us</Link>.
          </p>

          <h2>Changes</h2>
          <p>
            We may update this policy. We will update the "Last updated" date and, where appropriate,
            notify you in-app.
          </p>

          <h2>Contact</h2>
          <p>
            Questions or requests: visit our <Link to="/contact">Contact</Link> page.
          </p>

          <div className="legal-notice">
            <h3>Your Privacy Matters</h3>
            <p>
              We're committed to transparency and protecting your privacy. If you have any concerns
              or questions, we're here to help.
            </p>
            <Link to="/contact" className="btn-contact">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};
